import { useLayoutEffect, useRef } from "react";
import { colors } from "../../theme/colors";

/** Marks the aldabil dialog/popover paper so dark mode can restyle the shell. */
export function useSchedulerSurface() {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const paper = ref.current?.closest(".MuiDialog-paper, .MuiPopover-paper");
    if (!paper) return undefined;
    paper.classList.add("scheduler-surface");
    return () => paper.classList.remove("scheduler-surface");
  }, []);
  return ref;
}

export const CONTROL_RADIUS = "6px";

export const dialogPaperSx = {
  borderRadius: 2,
  overflow: "hidden",
};

export const dialogTitleSx = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  bgcolor: colors.black,
  color: colors.white,
  px: 2.5,
  py: 1.5,
};

export const dialogCloseIconSx = {
  color: colors.gold,
  "&:hover": { bgcolor: "rgba(197,160,111,0.15)" },
};

export const primaryBtnSx = {
  minHeight: 40,
  textTransform: "none",
  fontWeight: 700,
  borderRadius: CONTROL_RADIUS,
  bgcolor: colors.gold,
  color: colors.black,
  boxShadow: "none",
  "&:hover": {
    bgcolor: colors.goldHover,
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    bgcolor: "rgba(197,160,111,0.4)",
    color: "rgba(0,0,0,0.45)",
  },
};

export const secondaryBtnSx = {
  minHeight: 40,
  textTransform: "none",
  fontWeight: 600,
  borderRadius: CONTROL_RADIUS,
  color: (theme) =>
    theme.palette.mode === "dark" ? "#f2f2f2" : colors.black,
  borderColor: "divider",
};

export const outlinedBrandBtnSx = {
  ...secondaryBtnSx,
  border: "1px solid",
  borderColor: (theme) =>
    theme.palette.mode === "dark" ? "rgba(255,255,255,0.55)" : colors.black,
  "&:hover": {
    borderColor: (theme) =>
      theme.palette.mode === "dark" ? "rgba(255,255,255,0.55)" : colors.black,
    bgcolor: (theme) =>
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,0.06)"
        : "rgba(0,0,0,0.04)",
  },
};

export const fieldSx = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "background.paper",
    borderRadius: CONTROL_RADIUS,
  },
};

export const goldCheckboxSx = {
  color: colors.gold,
  "&.Mui-checked": { color: colors.gold },
};

export const goldRadioSx = {
  color: colors.gold,
  "&.Mui-checked": { color: colors.gold },
};
